<div class="reporting">
<iframe title="reports" width="1400" 
height="800" 
[src]="reportIssue | safeUrl"
frameborder="0" allowFullScreen="true"></iframe>
</div>
